import axios from "axios";
import API from "../api/axios.js";

export const getApplications = async () => {
    const response = await API.get("/dashboard");
    return response.data;
};

export const getAwardRanking = async () => {
    const response = await API.get("/application/ranking");
    return response.data;
};
